/**
 * Forward `cms_env` / `is_preview` from the page URL so pagination and
 * hash-slug lookups stay on the same Contentful env as the SSR page. Empty on
 * SSR or when neither is present.
 */
export function getForwardedEnvQuery(): string {
  if (typeof window === 'undefined') {
    return '';
  }

  const pageParams = new URLSearchParams(window.location.search);
  const forwarded = new URLSearchParams();
  const cmsEnv = pageParams.get('cms_env');
  if (cmsEnv) {
    // Forwarded verbatim so it reaches the server's allowlist unchanged.
    forwarded.set('cms_env', cmsEnv);
  }
  // Normalize to the literal 'true' so the continuation matches the page's
  // truthiness rendering instead of the API's strict === 'true' parse.
  if (pageParams.get('is_preview')) {
    forwarded.set('is_preview', 'true');
  }

  const serialized = forwarded.toString();
  return serialized ? `&${serialized}` : '';
}
